module.exports = __webpack_public_path__ + "img/商陆.4157e460.jpg";